import {Route, Routes} from "react-router-dom";
import List from "./List";
import Detail from "./Detail";
import Post from "./Post";
import {RouterProps} from "../../RouterProps";

export default function StorageKeyRouter(props: RouterProps) {
    return <>
        <Routes>
            <Route path={'/'} element={<List {...props} />} />
            <Route path={'/post'} element={<Post {...props} />} />
            <Route path={'/:envStorageKeyId'} element={<Detail {...props} />} />
        </Routes>
    </>
}